import { render, staticRenderFns } from "./RoomStatusCard.vue?vue&type=template&id=ed0e6210"
import script from "./RoomStatusCard.vue?vue&type=script&lang=js"
export * from "./RoomStatusCard.vue?vue&type=script&lang=js"
import style0 from "./RoomStatusCard.vue?vue&type=style&index=0&id=ed0e6210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports